import { render, staticRenderFns } from "./OkexFuturesMarketPrice.vue?vue&type=template&id=8fc5710c&"
import script from "./OkexFuturesMarketPrice.vue?vue&type=script&lang=js&"
export * from "./OkexFuturesMarketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports